import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function dutchSelectValidator(control: FormGroup): ValidationErrors | null {
    const dutch = control.value.studyDutchInSchool;
    const dutchStudyYears = control.value.dutchStudyYears;
    const dutchStydyHours = control.value.dutchStudyHours;
    const dutchTeacher = control.value.dutchTeacherName;

    return dutch && !(dutchStudyYears && dutchStydyHours && dutchTeacher) ? { "missingDutchStudyInfo": true } : null;
}